export default "__VITE_ASSET__B6LI$AMI__"